/** Yes/No codes mapped to Norwegian labels. */
export const yesNoNb: Record<string, string> = {
  "1": "Ja",
  "0": "Nei",
}

/** Sorted array of { code, name } for use in dropdowns. */
export const yesNoOptionsNb: Array<{ code: string; name: string }> = Object.entries(yesNoNb).map(([code, name]) => ({
  code,
  name,
}))
